export const animationRise = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0 },
  transition: { bounce: 0, duration: 0.5 },
};

export const animationFadeInOut = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.5 },
};

const staggerContainer = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2, // Delay between each item animation
    },
  },
  exit: {
    opacity: 0,
    transition: {
      staggerChildren: 0.2, // Delay between each item animation
    },
  },
};

export const animationStaggerContainer = {
  variants: staggerContainer,
  initial: "hidden",
  animate: "show",
  exit: "exit",
};

export const animationLeftSwipe = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.3 } },
  exit: { opacity: 0, transition: { duration: 0.3 } },
};

export const animationStaggerChildrenLeftSwipe = {
  variants: animationLeftSwipe,
};
